import { Box, Typography } from "@mui/material"
import React, { useCallback, useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { customPalette } from "../../../../../../../../../theme"
import { CustomBottomNavigation } from "../../../../../../../../components/buttons/navigate-button/CustomBottomNavigation"
import { IconInbox } from "../../../../../../../../components/custom-icons/icon-inbox"
import { SuccessContext } from "../../../../../../../../components/layout/success-snackbar"
import { pagesUrl } from "../../../../../../../../core/appConstants"
import { AppSideBarContext } from "../../../../../../../../core/context/AppSideBarContext/AppSideBarContext"
import { BSInputContext } from "../../../../../../../../core/context/beem-shot/BSInput/BSInputContext"
import { BSVariantContext } from "../../../../../../../../core/context/beem-shot/BSVariant/BSVariantContext"
import { AppNavBarContext, NavbarTypeEnum } from "../../../../../../../../core/context/nav-bar/AppNavBarContext"
import { CoverImgProjectContext } from "../../../../../../../../core/context/project/CoverImgProjectContext"
import { ProjectContext } from "../../../../../../../../core/context/project/ProjectContext"
import { useForm } from "../../../../../../../../core/hooks/form/use-form"
import { required } from "../../../../../../../../core/hooks/form/validation"
import { resolveUrl } from "../../../../../../../../core/services/http-service"
import {
  BSInputParkingForm,
  bsInputParkingFormToUpdateDto,
  bsParkingDtoToForm,
  IBSInputParkingForm,
} from "../../../tabs/BSBuildingTabs/BSBuildingParkingTab/components/BSInputParkingForm"
import { BSBuildingContext } from "../../components/context/BSBuildingContext"
import { BSParkingNoBimContainer } from "./components/BSParkingNoBimContainer"

export function BSParkingPage(): React.JSX.Element {
  const navigate = useNavigate()

  const { setShowAppSide, setFullScreen } = useContext(AppSideBarContext)
  const { setTypeNavBar, setImageFile, setIcon, setTitle, setPreviousUrl, setStepHeader } = useContext(AppNavBarContext)
  const { file } = useContext(CoverImgProjectContext)
  const { project } = useContext(ProjectContext)
  const { selectedVariant } = useContext(BSVariantContext)
  const { selectedBSBuilding } = useContext(BSBuildingContext)
  const { bsInput, updateBSInputParking } = useContext(BSInputContext)
  const openSuccessSnackbar = useContext(SuccessContext)

  useEffect(() => {
    setTypeNavBar(NavbarTypeEnum.BUILDING_HEADER)
    setImageFile(file)
    setIcon(<IconInbox sx={{ color: customPalette.black, fontWeight: "2px" }} />)
    setTitle(selectedVariant?.name ?? "")
    setPreviousUrl(resolveUrl(pagesUrl.BUILDING_CHOICE, [project?.id, selectedVariant?.id, selectedBSBuilding?.id]))

    setFullScreen(false)

    setStepHeader(2)
  }, [
    file,
    project?.id,
    selectedBSBuilding?.bim,
    selectedBSBuilding?.id,
    selectedVariant?.id,
    selectedVariant?.name,
    setFullScreen,
    setIcon,
    setImageFile,
    setPreviousUrl,
    setStepHeader,
    setTitle,
    setTypeNavBar,
  ])

  useEffect(() => {
    setShowAppSide(false)
  }, [setShowAppSide])

  const handleContinue: () => void = useCallback(() => {
    navigate(resolveUrl(pagesUrl.BUILDING_ZONE_AND_LEVEL, [project?.id, selectedVariant?.id, selectedBSBuilding?.id]))
  }, [navigate, project, selectedBSBuilding, selectedVariant])

  const submit: (form: IBSInputParkingForm) => Promise<any> = useCallback(
    (form) => {
      if (bsInput) {
        return updateBSInputParking(bsInputParkingFormToUpdateDto(form, bsInput.id)).then(() => {
          openSuccessSnackbar("Les parking ont été mis à jour.")
          handleContinue()
        })
      }
      return Promise.resolve()
    },
    [bsInput, handleContinue, openSuccessSnackbar, updateBSInputParking]
  )

  const { form, errors, handleChange, handleSubmit, isSubmitting } = useForm(
    bsInput,
    bsParkingDtoToForm,
    [required("typeParking"), required("nombrePlaceParking")],
    submit
  )

  return (
    <Box minHeight="100%" pt={3} display="flex" justifyContent="center" alignItems="center" flexDirection="column" gap={2}>
      <Typography variant="h5" fontWeight={600}>
        {selectedBSBuilding?.bim ? "Ajouter un parking non modélisé" : "Créer les parkings du bâtiment"}
      </Typography>

      {selectedBSBuilding?.bim ? (
        <Box component="form" id="update-bs-building-parking" width="80%" onSubmit={handleSubmit}>
          <BSInputParkingForm title="Stationnement" form={form} handleChange={handleChange} errors={errors} />

          <CustomBottomNavigation actionLabel="Continuer" formId="update-bs-building-parking" isSubmitting={isSubmitting} />
        </Box>
      ) : (
        <>
          <Box width="80%">
            <BSParkingNoBimContainer />
          </Box>

          <CustomBottomNavigation actionLabel="Continuer" validateAction={handleContinue} />
        </>
      )}
    </Box>
  )
}
